import { CLIENT_SETTINGS } from 'constants/clientSettings'
import DOMAIN from 'constants/domains'

/**
 * SAFICドメインか判定する
 * @returns SAFICドメインならtrue, それ以外ならfalseを返却する
 */
export const isSaficDomain = (): boolean => {
  return CLIENT_SETTINGS.targetDomain === DOMAIN.SAFIC
}

/**
 * SJドメインか判定する
 * @returns SJドメインならtrue, それ以外ならfalseを返却する
 */
export const isSjDomain = (): boolean => {
  return CLIENT_SETTINGS.targetDomain === DOMAIN.SJ
}

/**
 * 共済系ドメインか判定する
 * 共済系ドメインはZN、NKR
 * @returns 共済系ドメインならtrue, それ以外ならfalseを返却する
 */
export const isKsDomain = (): boolean => {
  return (
    CLIENT_SETTINGS.targetDomain === DOMAIN.ZN ||
    CLIENT_SETTINGS.targetDomain === DOMAIN.NKR
  )
}

/**
 * 共済系クライアントの小文字を返却する
 * @returns 共済系ドメインならそれぞれzn、nkr, それ以外ならundefinedを返却する(共済系クライアントではない場合)
 */
export const getKsClientLowerCase = (): string => {
  return {
    [DOMAIN.ZN]: 'zn',
    [DOMAIN.NKR]: 'nkr',
  }[getDomain()]
}

/**
 * 共済系クライアントのGAIDを返却する
 * @returns 共済系ドメインならstring, それ以外のドメイン、もしくは未定義ならundefinedを返却する
 */
export const getKsGaId = (): string | undefined => {
  return {
    [DOMAIN.ZN]: process.env.REACT_APP_QN_ZN_GA_ID,
    [DOMAIN.NKR]: process.env.REACT_APP_QN_NKR_GA_ID,
  }[getDomain()]
}

/**
 * SOMPOダイレクト(旧セゾン)クライアントのGAIDを返却する
 * @returns SOMPOダイレクト(旧セゾン)ドメインならstring, それ以外のドメイン、もしくは未定義ならundefinedを返却する
 */
export const getSaficGaId = (): string | undefined => {
  return {
    [DOMAIN.SAFIC]: process.env.REACT_APP_QN_SAFIC_GA_ID
  }[getDomain()]
}

/**
 * 現在のクライアント設定のドメインを取得する
 * @returns クライアント設定のドメイン
 */
export const getDomain = (): string => {
  return CLIENT_SETTINGS.targetDomain
}
